/**
 * Het afdelingsfilter van de kwalificatiematrix, met een standaard.
 *
 * Beide tabbladen ("Per medewerker" en "Wie kan wat") gebruiken deze hook, zodat
 * ze niet uit elkaar kunnen lopen.
 *
 * Twee dingen die makkelijk fout gaan en hier bewust zijn afgevangen:
 *
 * 1. **De standaard mag maar één keer gezet worden.** Zou hij bij elke render
 *    opnieuw worden opgelegd, dan springt het filter terug zodra de gebruiker
 *    "Alle afdelingen" kiest — een keuze die zichzelf ongedaan maakt.
 * 2. **Een onbekende afdelingsnaam levert géén lege lijst op.** Is de afdeling
 *    hernoemd of bestaat hij niet in deze omgeving, dan blijft het filter op
 *    "alle" staan. Zichtbaar, en niemand raakt iets kwijt.
 */
import { useEffect, useRef, useState } from 'react';
import { STANDAARD_KWALIFICATIE_AFDELING } from '@functieloonhuis/shared';

export interface AfdelingOptie {
  id: number;
  name: string;
}

export function useStandaardAfdeling(opties: AfdelingOptie[]) {
  const [departmentId, setDepartmentId] = useState<number | null>(null);
  const standaardGezet = useRef(false);

  useEffect(() => {
    if (standaardGezet.current || opties.length === 0) return;
    // Vanaf hier is de lijst binnen; of de standaard er nu in zit of niet, we
    // proberen het niet nog eens. Anders wint de standaard alsnog zodra de
    // gebruiker heeft omgeschakeld en de lijst opnieuw laadt.
    standaardGezet.current = true;
    const standaard = opties.find((o) => o.name === STANDAARD_KWALIFICATIE_AFDELING);
    if (standaard) setDepartmentId(standaard.id);
  }, [opties]);

  return { departmentId, setDepartmentId };
}
